import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBBusinessNameSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="businessName"
            formName="businessName"
            label="businessName"
        />
    )
}

export default CBBusinessNameSearchFilter;